<ng-container *ngIf="user">
  <app-toolbar [title]="title" [user]="user" [destination]="destination" [back]="back"></app-toolbar>
</ng-container>

<h2 style="text-align: center; padding-top: 20px; padding-bottom: 20px">Impostazioni</h2>

<div style="padding-bottom: 40px">
  <mat-card class="mat-elevation-z5">
    <mat-card-content>
      <h2 style="text-align: center">Dati personali</h2>
      <ng-container *ngIf="!editing; else edit">
        <hr>
        <div style="text-align: center; margin-top: 15px">
          <button mat-raised-button color="primary" (click)="modify()">Modifica</button>
        </div>
        <mat-list>
          <mat-list-item><strong>Nome:</strong>&nbsp;&nbsp;{{user.name}}</mat-list-item>
          <mat-list-item><strong>Cognome:</strong>&nbsp;&nbsp;{{user.surname}}</mat-list-item>
          <mat-list-item><strong>Codice fiscale:</strong>&nbsp;&nbsp;{{user.ssn}}</mat-list-item>
          <mat-list-item><strong>Cellulare:</strong>&nbsp;&nbsp;{{user.phoneNumber}}</mat-list-item>
          <mat-list-item><strong>Data di nascita:</strong>&nbsp;&nbsp;{{birthDate}}</mat-list-item>
          <mat-list-item><strong>Luogo di nascita:</strong>&nbsp;&nbsp;{{user.birthPlace}}</mat-list-item>
        </mat-list>
      </ng-container>
      <ng-template #edit>
        <hr>
        <form class="form" [formGroup]="editingForm" (ngSubmit)="onSubmit(editingForm.value)">

          <div style="text-align: center; margin-top: 15px">
            <button mat-raised-button type="submit" color="primary">
                  <!--[disabled]="!editingForm.valid"-->Conferma</button>
          </div>
        <mat-list fxLayout="column wrap">

          <mat-list-item>
            <strong>Nome:</strong>
            <mat-form-field style="margin-left: 8px; margin-top: 9px">
              <input matInput formControlName="name" (focusin)="notFocused=false" (focusout)="notFocused=true">
            </mat-form-field>
          </mat-list-item>

          <mat-list-item>
            <strong>Cognome:</strong>
            <mat-form-field style="margin-left: 8px; margin-top: 9px">
              <input matInput formControlName="surname" (focusin)="notFocused=false" (focusout)="notFocused=true">
            </mat-form-field>
          </mat-list-item>

          <mat-list-item>
            <strong>Codice fiscale:</strong>
            <mat-form-field style="margin-left: 8px; margin-top: 9px">
              <input matInput formControlName="ssn" (focusin)="notFocused=false" (focusout)="notFocused=true">
            </mat-form-field>
          </mat-list-item>

          <mat-list-item>
            <strong>Cellulare:</strong>
            <mat-form-field style="margin-left: 8px; margin-top: 9px">
              <input matInput formControlName="phoneNumber" (focusin)="notFocused=false" (focusout)="notFocused=true">
            </mat-form-field>
          </mat-list-item>

          <mat-list-item>
            <strong>Data di nascita:</strong>
            <mat-form-field style="margin-left: 8px; margin-top: 9px">
              <input matInput formControlName="birthDate" [matDatepicker]="picker" (dateChange)="setDate($event)">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker [startAt]="user.birthDate" #picker></mat-datepicker>
            </mat-form-field>
          </mat-list-item>

          <mat-list-item>
            <strong>Luogo di nascita:</strong>
            <mat-form-field style="margin-left: 8px; margin-top: 8px; width: 400px">
              <mat-label>Inserisci nel formato: Comune (Provincia) - CAP</mat-label>
              <input matInput formControlName="birthPlace" (focusin)="notFocused=false" (focusout)="notFocused=true">
            </mat-form-field>
          </mat-list-item>

        </mat-list>
        </form>
      </ng-template>

      <ng-container *ngIf="user.role.includes('DOTTORE')">
        <h2 style="text-align: center">Impostazione chat</h2>
        <ng-container>
          <hr>
          <mat-list>
            <mat-list-item><strong>Notifiche attive:</strong>&nbsp;&nbsp;&nbsp;&nbsp;<mat-slide-toggle [(ngModel)]="isNotifyEnabled" (change)="toggle($event)"></mat-slide-toggle></mat-list-item>
          </mat-list>
        </ng-container>
      </ng-container>
    </mat-card-content>

  </mat-card>
</div>
